"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
function PackageSwitchRight(props) {
    var rightTitle = props.rightTitle, rightDesc = props.rightDesc, colorTheme = props.colorTheme, onCallback = props.onCallback, extendProps = props.extendProps, btnTxt = props.btnTxt;
    // 默认进入页面的主题色渲染
    var themeClass = colorTheme ? "".concat(colorTheme, "-theme") : '';
    return (react_1.default.createElement("div", { className: "item-right" },
        react_1.default.createElement("div", { className: "item-right-inner" },
            react_1.default.createElement("div", { className: (0, classnames_1.default)('item-right-title', themeClass) }, rightTitle),
            react_1.default.createElement("div", { className: "item-right-desc" }, rightDesc),
            react_1.default.createElement("div", { className: "item-right-btn" },
                react_1.default.createElement("div", __assign({ className: (0, classnames_1.default)('item-right-btn-txt', themeClass), onClick: function () {
                        onCallback === null || onCallback === void 0 ? void 0 : onCallback();
                    } }, (extendProps || {})), btnTxt)))));
}
exports.default = PackageSwitchRight;
//# sourceMappingURL=PackageSwitchRight.js.map